import { render, staticRenderFns } from "./IPassMoneyPay.vue?vue&type=template&id=6a5912cd"
import script from "./IPassMoneyPay.vue?vue&type=script&lang=js"
export * from "./IPassMoneyPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports